import React from 'react';
import ConfirmDeleteDrawer from 'src/components/20-helper-views/bottom-drawer/common-drawers/ConfirmDelete';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import useI18n from 'src/modules/translations/hooks/useI18n';
import useData from './useData';
const DeleteNoteTabDrawer = ({ noteID, noteTab, onDelete, onCancel, }) => {
    const { translate } = useI18n();
    const [state, actions] = useData(noteID, noteTab);
    const handleDelete = async () => {
        await actions.deleteTab();
        bottomDrawerHelperActions.hide();
        onDelete();
    };
    const handleCancel = () => {
        bottomDrawerHelperActions.hide();
        onCancel?.();
    };
    return (React.createElement(ConfirmDeleteDrawer, { title: translate('Delete Tab'), msg: translate('Are you sure you want to delete this tab? This action cannot be undone.'), deleteLoading: state.removeNoteTabMutation.loading, onDelete: handleDelete, onCancel: handleCancel }));
};
export default DeleteNoteTabDrawer;
